import React from 'react';
export function Footer() {
  const handleServiceClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    // If not on landing page, navigate there first
    if (window.location.hash !== '#/' && window.location.hash !== '') {
      window.location.hash = '#/';
      // Wait for navigation, then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Already on landing page, just scroll
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-53">
          <div data-id="element-54">
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-55">
              ellner<span className="font-light" data-id="element-56">consultancy</span>
            </span>
            <p className="mt-4 text-sm leading-relaxed max-w-xs" data-id="element-57">
              Professionelles Projektmanagement für Banken und Großunternehmen.
              Excellence in Execution.
            </p>
          </div>

          <div data-id="element-58">
            <h4 className="text-white font-semibold mb-4" data-id="element-59">Leistungen</h4>
            <ul className="space-y-2 text-sm" data-id="element-60">
              <li data-id="element-61">
                <a href="#services" onClick={e => handleServiceClick(e, 'services')} className="hover:text-blue-400 transition-colors" data-id="element-62">
                  PM Schulungen
                </a>
              </li>
              <li data-id="element-63">
                <a href="#services" onClick={e => handleServiceClick(e, 'services')} className="hover:text-blue-400 transition-colors" data-id="element-64">
                  PM as a Service
                </a>
              </li>
              <li data-id="element-65">
                <a href="#services" onClick={e => handleServiceClick(e, 'services')} className="hover:text-blue-400 transition-colors" data-id="element-66">
                  Freelance Experts
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-67">
            <h4 className="text-white font-semibold mb-4" data-id="element-68">Rechtliches</h4>
            <ul className="space-y-2 text-sm" data-id="element-69">
              <li data-id="element-70">
                <a href="#/impressum" className="hover:text-blue-400 transition-colors" data-id="element-71">
                  Impressum
                </a>
              </li>
              <li data-id="element-72">
                <a href="#/datenschutz" className="hover:text-blue-400 transition-colors" data-id="element-73">
                  Datenschutz
                </a>
              </li>
              <li data-id="element-74">
                <a href="#/agb" className="hover:text-blue-400 transition-colors" data-id="element-75">
                  AGB
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-76">
          <p data-id="element-77">
            &copy; {new Date().getFullYear()} ellner consultancy. Alle Rechte
            vorbehalten.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-78">Made in Germany</p>
        </div>
      </div>
    </footer>;
}